export default ({ buttons: { buttonToggleGroup } }) => ({
  root: {
    color: buttonToggleGroup.fontColor,
    fontSize: buttonToggleGroup.fontSize,
    fontFamily: buttonToggleGroup.fontFamily,
    lineHeight: buttonToggleGroup.lineHeight,

    '&:not(:last-child):not(:active):not(:focus)': {
      borderRight: 'none'
    },

    '&:active + button, &:focus + button': {
      borderLeft: 'none'
    },

    '&:first-child': {
      borderRadius: `${buttonToggleGroup.borderRadius}px 0 0 ${buttonToggleGroup.borderRadius}px`
    },

    '&:last-child': {
      borderRadius: `0 ${buttonToggleGroup.borderRadius}px ${buttonToggleGroup.borderRadius}px 0`
    },

    background: buttonToggleGroup.toggleBackground,
    border: `1px solid ${buttonToggleGroup.toggleBorderColor}`,
    padding: buttonToggleGroup.togglePadding,

    '&$selected': {
      background: buttonToggleGroup.selectedToggleBackground
    },

    '&:active, &:focus, &:hover': {
      outline: 'none',
      borderColor: buttonToggleGroup.focusBorderColor,
      borderWidth: buttonToggleGroup.focusBorderWidth,
      padding: buttonToggleGroup.focusPadding,
      background: buttonToggleGroup.selectedToggleBackground
    }
  },

  selected: {}
});
